import ReactModal from "react-modal";
import TierList from "../components/tierList";
import { useCallback, useState } from "react";
import { boardGameList } from "../../lists/boardGameLists";

export default function BoardGames() {

    const [showModal, setShowModal] = useState(false);
    const handleOpenModal = useCallback((index) => {
        setShowModal(true);
    }, []);
    const handleCloseModal = useCallback((index) => {
        setShowModal(false);
    }, []);

    return (
        <>

            <div className="gaming-tier-list-button" onClick={handleOpenModal}>
                <img
                    src={process.env.PUBLIC_URL + "/images/gaming/boardGames.png"}
                    className="gaming-card-icon"
                    alt="videoGameIcon"
                />
                <div className="index-card-header">Board Game Tier List</div>
            </div>

            <div className="mt-5 col-12 col-md-4">
                <ReactModal
                    isOpen={showModal}
                    contentLabel="Minimal Modal Example"
                >
                    <TierList
                        items={boardGameList}
                    />
                    <button onClick={handleCloseModal}>Close Window</button>
                </ReactModal>
            </div>
        </>
    )
}
